export default __webpack_public_path__ + "static/media/Group.639fabf3.svg";